import { render, staticRenderFns } from "./SleepApneaSvg.vue?vue&type=template&id=479e75b4&"
import script from "./SleepApneaSvg.vue?vue&type=script&lang=js&"
export * from "./SleepApneaSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports